import { Link } from "react-router-dom";
import { ArrowRight, BadgeCheck, Users } from "lucide-react";
import { APP_ROUTES } from "../../routes/AppRoutes";
import SectionHeader from "../eventsExperiences/SectionHeader";
// Placeholder photos until the final creator images are ready.
import nanoImg from "../../assets/images/whatwedo/influencerMarketing/tiers/microCreator.jpg";
import macroImg from "../../assets/images/whatwedo/influencerMarketing/tiers/macro.jpg";
import megaImg from "../../assets/images/whatwedo/whatwedo2.jpg";

const TIERS = [
  { tag: "High trust", image: nanoImg, name: "Nano & Micro", sub: "creators", note: "Smaller, loyal audiences", chips: ["Product seeding", "Local reach", "UGC"] },
  { tag: "Larger reach", image: macroImg, name: "Macro", sub: "creators", note: "Strong content quality", chips: ["Launches", "Awareness pushes"] },
  // `focus` keeps the singer (right side of a landscape photo) in the tall card.
  { tag: "Maximum scale", image: megaImg, focus: "84% 50%", name: "Mega", sub: "& celebrities", note: "Scale and recall", link: { to: APP_ROUTES.CELEBRITY_MARKETING, label: "Celebrity Marketing" } },
];

// Profile-style cards for each creator tier.
const InfluencerTiers = () => (
  <section className="ee-section im-tiers">
    <div className="container">
      <SectionHeader
        eyebrow="Creator tiers"
        title="Creators for"
        accent="every goal."
        intro="We match creator size to what you want to achieve."
      />
      <div className="im-tier-row">
        {TIERS.map(({ tag, image, focus, name, sub, note, chips, link }, i) => (
          <div className="im-tier-slot" key={name} data-aos="fade-up" data-aos-once="true" data-aos-delay={i * 120}>
            <article className={`im-tier-card${i === 0 ? " is-cutout" : ""}`}>
              <img src={image} alt="" loading="lazy" style={{ objectPosition: focus }} />
              <span className="im-tier-tag">{tag}</span>
              <span className="im-tier-bar" aria-hidden="true" />
              <div className="im-tier-info">
                <span className="im-tier-note"><Users size={14} /> {note}</span>
                <h3>
                  {name}, <span>{sub}</span> <BadgeCheck className="im-tier-check" size={20} aria-hidden="true" />
                </h3>
                <div className="im-tier-chips">
                  {chips?.map((chip) => <span key={chip}>{chip}</span>)}
                  {link && <Link to={link.to}>{link.label} <ArrowRight size={14} /></Link>}
                </div>
              </div>
            </article>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default InfluencerTiers;
